<template>
  <a-form-item
    :ref="reference"
    :label="name"
    :name="reference"
    :required="isRequired"
  >
    <a-select
      placeholder="Selecione"
      show-search
      option-filter-prop="children"
      v-model:value="vForm[reference]"
      :filter-option="filterOption"
      firstActiveValue="SPL"
      :readonly="readOnlyForm"
      @change="readOnlyChange"
    >
      <a-select-option
        v-for="(country, index) in AVAILABLE_CONSULS"
        :value="index"
        :key="index"
        >{{ country }}</a-select-option
      >
    </a-select>
  </a-form-item>
</template>
<script>
import { defineComponent } from "vue";
import { mapMutations, mapState, mapGetters } from "vuex";
import { AVAILABLE_CONSULS } from "@/utils/Constants";
export default defineComponent({
  props: {
    reference: { type: String, isRequired: true },
    name: { type: String, required: true },
    isRequired: { type: Boolean, default: false },
  },
  data() {
    return {
      AVAILABLE_CONSULS,
    };
  },
  computed: {
    ...mapState("application", ["vForm", "application"]),
    ...mapGetters("application", ["readOnlyForm"]),
  },
  methods: {
    ...mapMutations("application", ["setSaveFilledForm"]),
    filterOption(input, option) {
      return (
        option.children[0].children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    readOnlyChange() {
      if (this.readOnlyForm) {
        this.vForm[this.reference] = this.application.content[this.reference];
      }
    },
  },
});
</script>

<style module src="./style.scss" lang="scss"></style>
